export default __webpack_public_path__ + "static/media/kelley_withy.66642194.jpg";